import { gql } from '@apollo/client';

export default gql`
  query places($page: Int, $name: String, $sortBy: String) {
    space {
      overPlacesLimit
      adminRole
    }
    places(page: $page, name: $name, sortBy: $sortBy) {
      placesTotalPages
      placesTotal
      perPage
      hasNextPage
      places {
        id
        name
        street
        zipCode
        city
        phone
        inspectionSubjectsTotal
        inspectionsTotal
        incomingInspectionsTotal
        overdueInspectionsTotal
        createdAt
        updatedAt
      }
    }
  }
`;
